import { res } from "../../language/text/res";

export enum CredentialStatus {
    INACTIVE = 0,
    ACTIVE = 1,
    CONFIRMED = 2
}

export const CredentialStatusTranslation = {
    [CredentialStatus.INACTIVE]: res.Inactive,
    [CredentialStatus.ACTIVE]: res.Active,
    [CredentialStatus.CONFIRMED]: res.Confirmed
}